import classNames from "classnames"
import React from "react";

import "./SectionHeading.scss";

interface Props {

  /**
   * Title
   */
  title: string;
    
  /**
   * Pre-title (appears just above title)
   */
  preTitle?: string;

  /**
   * Alignment
   */
  alignment: "left" | "centered" | "right";
}

/**
 * Used as the heading element to many sections of the home page.
 * 
 * @status development
 */
export const SectionHeading: React.FC<Props> = ({ title, preTitle, alignment }) => {

  const text_alignment = 'has-text-' + alignment;

  return (
    <div className={classNames("section-heading", text_alignment) }>

      <div className="section-heading__content">

        <h2 className={classNames("section-heading__title", "heading--2")}>{title}</h2>        

        {preTitle && <p className={classNames("section-heading__pretitle", "text--label")}>{preTitle}</p>}

      </div>

      <hr className="section-heading__hr"></hr>

    </div>
  );
};
